import React, { createRef, useEffect, useRef, useState } from 'react'
import * as routeLink from "./../../constants/routeLink";

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { addRef, claim, formatTimestamp, getUser, history } from '../../services/services';
// import Pagination from '../../components/Pagiantion';
import { ToastContainer, toast } from 'react-toastify';
import Pagination from '../../components/Pagiantion';
import { formatNumber, formatTimestamp, history, rateExchange } from '../../services/services';

const History = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const countdownref = useRef();
  const navigate = useNavigate();
  const [showClaim, setShowClaim] = useState(false);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [tabindex, settabindex] = useState("all");
  const [curentPage, setcurentPage] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [dataHistory, setdataHistory] = useState([]);

  useEffect(() => {

    const getHistory = async () => {
      const res = await history(tabindex, curentPage);
      if (res.code == 200) {
        setdataHistory(res.data);
        if (res.message) {

          settotalPages(res.message.totalPage);
        }
      } else {
        if (res.message) {
          toast(res.message);
        }
      }

    }
    getHistory();


    return () => {

    };
  }, [tabindex, curentPage]);
  const onPageChange = (page) => {
    setcurentPage(page);
  }
  console.log("dataHistorydataHistory ", dataHistory);

  return (


    <section class="affiliatePage w-100 d-flex justify-content-center align-items-center">
      <div className='row  w-100'>
        <div class="col-sm-12 col-md-12 col-lg-12   mt-5">
          <p class="text-white fs-4">History</p>
          <div class="bg-unset border-unset text-white fs-5 ">
            <div class="card-custom borderSecondary2 bgSecondary4 ">
              <div class="card-top d-flex justify-content-between align-items-center borderBtSecondary3 llodoasdllsadowldsdjasd">
                <div class="tab d-flex align-items-start w-100" style={{ justifyContent: 'space-between' }}>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "all" ? "active" : ""}`} onClick={() => settabindex("all")}>All</button>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "deposit" ? "active" : ""}`} onClick={() => settabindex("deposit")} >Dep</button>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "withdraw" ? "active" : ""}`} onClick={() => settabindex("withdraw")}>Wdr</button>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "upgrade" ? "active" : ""}`} onClick={() => settabindex("upgrade")}>Upgrade</button>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "claim" ? "active" : ""}`} onClick={() => settabindex("claim")}>Claim</button>
                  <button
                    class={`button  d-flex justify-content-center align-items-center text-white px-2 py-2 font-12 text-white ${tabindex == "commission" ? "active" : ""}`} onClick={() => settabindex("commission")}>Comm</button>
                </div>
              </div>
              {!dataHistory || dataHistory.length <= 0 && <div class="card-body p-3 d-flex justify-content-center align-items-center">
                <span class="text-white fs-6">empty</span>
              </div>}

            </div>
          </div>
          <div className='list-history'>

            {dataHistory && dataHistory.length > 0 && dataHistory.map((value, index) => {

              return <div key={index} class="card-custom borderSecondary2 bgSecondary4 mt-4 ">
                <div class="card-top d-flex justify-content-start align-items-start borderBtSecondary3 p-3 item-list-3 ">
                  <div className='w-15'>
                    <img src={`${routeLink.domain}/assets/imgs/footprintDog.png`} style={{ maxWidth: 45 }} />
                  </div>
                  <div className='w-55'>
                    <div className='d-flex'>
                      <span className='text-white text-small me-2'>created: </span>
                      <span className='text-white text-xsmall text-wrap  text-break '>{formatTimestamp(value.created)}</span>
                    </div>
                    {value.type == "upgrade" && <div className='d-flex'>
                      <span className='text-white text-small me-2'>Amount USDT: </span>
                      <span className='text-white text-small text-wrap  text-break'>${formatNumber((value.amount / rateExchange) * value?.description?.priceTon)}</span>
                    </div>
                    }
                    {value.type == "commission" && <div className='d-flex'>
                      <span className='text-white text-small me-2'>Amount: </span>
                      <span className='text-white text-small text-wrap  text-break'>{Number(value.amount).toFixed(10)}</span>
                    </div>
                    }
                    {value.type != "commission" && <div className='d-flex'>
                      <span className='text-white text-small me-2'>Amount: </span>
                      <span className='text-white text-small text-wrap  text-break'>{Number(value.amount).toFixed(2)}</span>
                    </div>
                    }

                    <div className='d-flex'>
                      <span className='text-white text-small me-2'>symbol: </span>
                      <span className='text-white text-small text-wrap  text-break'>{value.symbol == "Point" ? "CoinX" : value.symbol}</span>
                    </div>

                    {/* {value.type == "bet" && <div className='d-flex'>
                      <span className='text-white text-small me-2'>result: </span>
                      <span className='text-white text-small text-wrap  text-break'>{value?.description?.result}</span>
                    </div>
                    }
                    {value.type == "bet" && <div className='d-flex'>
                      <span className='text-white text-small me-2'>Type: </span>
                      <span className='text-white text-small text-wrap  text-break'>{value?.description?.type}</span>
                    </div>
                    } */}
                  </div>
                  <div className=' boder-left-main ps-2 w-30'>
                    <span className='text-white'>{value.type}</span>
                    {value.status == "completed" && <div className='text-success'> {value.status}</div>}
                    {value.status != "completed" && <div className='text-danger'> {value.status}</div>}
                  </div>
                </div>

              </div>
            })}

          </div>
        </div>
        <Pagination totalPages={totalPages} currentPage={curentPage} onPageChange={onPageChange} />
        {/* <div className='pagination-his d-flex justify-content-center align-items-center mt-3'>
                    <button className='button second-normal btnMainBorder px-3 py-2 me-2'>1</button>
                    <button className='button second-normal btnMainBorder px-3 py-2 me-2'>1</button>
        </div> */}
      </div>
    </section>

  )
}

export default History;
